import { GetMerchantLocationMenus } from '__generated__/types'
import differenceInDays from 'date-fns/differenceInDays'
import parseISO from 'date-fns/parseISO'

export const menuItemIsSnoozed = (
  menuItem: GetMerchantLocationMenus.MenuItems
): boolean => {
  const { snoozedAt, snoozedUntil } = menuItem
  if (!snoozedAt || !snoozedUntil) {
    return false
  }
  const now = new Date()
  return now > new Date(snoozedAt) && now < new Date(snoozedUntil)
}

/*
 * Returns the menu categories which are currently available, or if no menus are
 * within their availability hours, return the next menu categories which will
 * become available.
 */
export function filterNextAvailableMenus(
  menus: GetMerchantLocationMenus.Menus[] = []
): GetMerchantLocationMenus.MenuCategories[] {
  let currentOrNextAvailableMenus: GetMerchantLocationMenus.Menus[] = []
  const availableMenus = menus.filter((menu) => menu.isAvailable)

  if (availableMenus.length) {
    currentOrNextAvailableMenus = availableMenus
  } else {
    const nextAvailableAt = nextMenuAvailableAt(menus)
    // If two menus will both become available at the same time in the future,
    // we want to return both of those menus.
    currentOrNextAvailableMenus = menus.filter(
      (menu) => menu.nextAvailableAt === nextAvailableAt
    )
  }

  return currentOrNextAvailableMenus.flatMap((menu) => {
    return menu.menuCategories.map((category) => ({
      ...category,
      menuItems: category.menuItems.filter(
        (menuItem) => !menuItemIsSnoozed(menuItem)
      )
    }))
  })
}

/*
 * Returns the first ISO 8601 datetime that one of the given menus will become
 * available.
 */
export function nextMenuAvailableAt(
  menus: { nextAvailableAt?: any }[] = []
): string | null {
  // First create a new array so `menus` is not mutated
  const nextAvailableMenu = Array.from(menus)
    .filter((menu) => !!menu.nextAvailableAt)
    .sort((a, b) => {
      return (
        new Date(a.nextAvailableAt).getTime() -
        new Date(b.nextAvailableAt).getTime()
      )
    })[0]
  if (nextAvailableMenu) {
    return nextAvailableMenu.nextAvailableAt
  }
  return null
}

export function isPausedIndefinitely(
  nextAvailableAt: string | null | undefined
): boolean {
  if (!nextAvailableAt) {
    return false
  }
  if (differenceInDays(parseISO(nextAvailableAt), new Date()) >= 7) {
    return true
  }
  return false
}
